define("shared/utils/plan-route/index", ["exports", "shared/utils/plan-route/tables", "shared/utils/plan-score"], function (_exports, _tables, _planScore) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.resolveDestination = resolveDestination;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/plan-route/tables",0,"shared/utils/plan-score"eaimeta@70e063a35619d71f
  function resolveDestination(answers) {
    const goal = (0, _planScore.statedGoal)(answers.goal);
    return goal === undefined ? _tables.DEFAULT_DESTINATION : _tables.GOAL_DESTINATION[goal];
  }
});